import { render, staticRenderFns } from "./ColorKitWhyMatch.vue?vue&type=template&id=73a352d7&scoped=true&lang=pug&"
import script from "./ColorKitWhyMatch.vue?vue&type=script&lang=js&"
export * from "./ColorKitWhyMatch.vue?vue&type=script&lang=js&"
import style0 from "./ColorKitWhyMatch.vue?vue&type=style&index=0&id=73a352d7&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a352d7",
  null
  
)

export default component.exports